'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToCartButton = exports.CLASS_BUTTON_DISABLE = exports.CLASS_UNAVAILABLE = exports.CLASS_DISABLED = exports.PRODUCT_QTY_SELECTOR = exports.ADD_NOTIFICATION = exports.ADD_BUTTON = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../../process/pc-slate-tools');

var _VariantSelector = require('./../variant/VariantSelector');

var _Loader = require('./../loader/Loader');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Add To Cart Button
 *    Contains scrits for add to cart button for product templates
 *
 *  Version:
 *    1.0.0 - 2019/01/24
 */
var ADD_BUTTON = exports.ADD_BUTTON = '[data-add-to-cart-button]';
var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = '[data-add-to-cart-notification]';
var PRODUCT_QTY_SELECTOR = exports.PRODUCT_QTY_SELECTOR = '[data-quantity-selector]';

var CLASS_DISABLED = exports.CLASS_DISABLED = 'is-disabled';
var CLASS_UNAVAILABLE = exports.CLASS_UNAVAILABLE = 'is-not-avalable';
var CLASS_BUTTON_DISABLE = exports.CLASS_BUTTON_DISABLE = 'is-not-available';

var AddToCartButton = exports.AddToCartButton = function () {
  function AddToCartButton(template, container, pricingTiers, productJson) {
    var _this = this;

    (0, _classCallCheck3.default)(this, AddToCartButton);

    this.template = template;
    this.container = container;
    this.cartPending = false;
    this.productJson = productJson;

    //Elements
    this.button = container.find(ADD_BUTTON);
    this.qtySelector = container.find(PRODUCT_QTY_SELECTOR);
    this.notification = container.find(ADD_NOTIFICATION);

    //Get pricing tiers
    this.pricingTiers = JSON.parse(pricingTiers.html());

    (0, _jquery2.default)(document).on(_VariantSelector.ON_VARIANT_CHANGE, function (e, variant) {
      return _this.useVariant(variant);
    });
    // $(document).on(ON_CART_PENDING, () => this.onCartPending());
    // $(document).on(ON_CART_FINISHED, () => this.onCartFinished());
    container.on('click', ADD_BUTTON, function (e) {
      return _this.onAddClick(e);
    });

    this.useVariant(this.getVariantData());
  }

  (0, _createClass3.default)(AddToCartButton, [{
    key: 'getVariantData',
    value: function getVariantData() {
      var vs = this.template.variantSelector;
      return vs.getVariantData();
    }
  }, {
    key: 'updateButton',
    value: function updateButton(variant, id) {
      //Adjust the add to cart button based on QTY available and in cart
      var _variant$product = variant.product,
          available = _variant$product.available,
          inventory_policy = _variant$product.inventory_policy,
          inventory_management = _variant$product.inventory_management,
          inventory_quantity = _variant$product.inventory_quantity;

      var inCart = (0, _pcSlateTools.getCountOfVariantInCart)(id);
      // let variants = variant.product.variants;

      available = variant.available;

      if (available) {
        if (inventory_policy != 'continue' && inventory_management != null && inventory_quantity - inCart <= 0) {
          available = false;
          this.button.html('' + Language.strings['products.product.all_in_cart']);
          this.button.attr('disabled', 'disabled');
          this.button.addClass(CLASS_DISABLED);
          this.qtySelector.addClass(CLASS_UNAVAILABLE);
        } else {
          this.button.html('' + Language.strings['products.product.add_to_cart']);
          this.button.removeAttr('disabled', 'disabled');
          this.button.removeClass(CLASS_DISABLED);
          this.qtySelector.removeClass(CLASS_UNAVAILABLE);
        }
      } else {
        this.button.html('' + Language.strings['products.product.sold_out']);
        this.button.attr('disabled', 'disabled');
        this.button.addClass(CLASS_DISABLED);
        this.qtySelector.addClass(CLASS_UNAVAILABLE);
      }
    }
  }, {
    key: 'useVariant',
    value: function useVariant(variant) {
      if (this.cartPending) return; //Don't update the button if the cart is pending
      var available = variant.available,
          inventory_policy = variant.inventory_policy,
          inventory_quantity = variant.inventory_quantity,
          inventory_management = variant.inventory_management,
          id = variant.id;

      this.updateButton(variant, id);
    }
  }, {
    key: 'onCartPending',
    value: function onCartPending() {
      this.cartPending = true;

      this.button.addClass('is-disabled');
      this.button.attr('disabled', 'disabled');
      this.button.html((0, _Loader.generateLoader)(null, null, null, 16));
    }
  }, {
    key: 'onCartFinished',
    value: function onCartFinished() {
      this.cartPending = false;
      this.useVariant(this.getVariantData());
    }
  }, {
    key: 'onAddClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _this2 = this;

        var id, variant, qty, product;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();
                id = this.getVariantData().id;
                variant = this.getVariantData(id);
                qty = this.qtySelector.find('[data-quantity-selector-field]').val();

                if (!this.button.hasClass(CLASS_DISABLED)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                _context.prev = 7;

                this.button.html('' + Language.strings['products.product.cart_pending']);
                _context.next = 11;
                return (0, _pcSlateTools.addToCart)(id, qty, this.pricingTiers);

              case 11:
                this.wasAdded = true; //This will tell our button to temporarily display the "Was added" text
                (0, _jquery2.default)('[data-show-cart-drawer]').click();
                product = this.productJson;


                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'page_type': 'add_to_cart',
                  'event': 'MagnetUK_add_to_cart', //create a custom event in GTM
                  'items': [{
                    'item_id': product.variants[0].sku,
                    'item_name': product.name,
                    'price': product.price / 100,
                    'item_brand': product.vendor,
                    'item_category': product.collection,
                    'item_list_name': product.collection,
                    'description': product.description,
                    'quantity': qty
                  }]
                });

                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](7);

                console.error(_context.t0);
                if (_context.t0.description) alert(_context.t0.description);
                return _context.abrupt('return');

              case 23:

                this.button.html('' + Language.strings['products.product.added_to_cart']);
                setTimeout(function () {
                  return _this2.updateButton(variant, id);
                }, 3500);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 18]]);
      }));

      function onAddClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onAddClick;
    }()
  }]);
  return AddToCartButton;
}();